export default {
      id: "averses-de-pluie-moderee-usage",
      viewBox: "0 0 91 91",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#averses-de-pluie-moderee-usage",
      toString: function () {
        return this.url;
      }
    }